import { relativeRowToRowId } from "@package/grid-utils";

const ROW_TYPE_SUFFIX = /^(mth|qtr|hlv|season|cal|adhoc)$/i;

export function buildRowId(rowId: string, rowType: string) {
  return `${rowId}:${rowType}`;
}

export function getRowId(rowId: string) {
  if (!rowId.includes(":")) return rowId;

  const lastColon = rowId.lastIndexOf(":");
  const maybeType = rowId.slice(lastColon + 1);
  // Strip formulas use `:` between legs (`FEB26:MAR26`). Only peel a known row type.
  if (ROW_TYPE_SUFFIX.test(maybeType)) return rowId.slice(0, lastColon);
  return rowId;
}

export function getRowType(rowId: string) {
  if (!rowId.includes(":")) return null;

  const lastColon = rowId.lastIndexOf(":");
  const maybeType = rowId.slice(lastColon + 1);
  return ROW_TYPE_SUFFIX.test(maybeType) ? maybeType : null;
}

// Older rules store a relative row ("REL-M0") rather than an absolute period.
export function rowIdToPeriod(rowId: string) {
  const id = getRowId(rowId);
  return id.startsWith("REL-") ? (relativeRowToRowId[id] ?? "") : id;
}
